/* eslint-disable no-param-reassign */
function constructPagination({ pages, page }) {
  const firstPage = 1;
  const lastPage = pages;
  const activePage = page + 1;

  // Show all pages if 10 or fewer
  if (pages <= 7) {
    return [...Array.from(Array(pages), (v, i) => ++i)];
  }

  // Near start
  if (activePage < 5) {
    return [...Array.from(Array(6), (v, i) => ++i), "...", lastPage];
  }

  // Near end
  if (activePage > lastPage - 5) {
    return [
      firstPage,
      "...",
      ...Array.from(Array(6), (v, i) => lastPage - i).reverse()
    ];
  }

  // Middle case - calculate the range
  const rangeStart = Math.max(activePage - 4, firstPage);
  const rangeEnd = Math.min(activePage + 4, lastPage);
  const range = Array.from(
    { length: rangeEnd - rangeStart + 1 },
    (_, i) => rangeStart + i
  );

  // Add start ellipsis if needed
  const needsStartEllipsis = rangeStart > firstPage + 1;
  const prefix = needsStartEllipsis
    ? [firstPage, "..."]
    : rangeStart === firstPage + 1
    ? [firstPage]
    : [];

  // Add end ellipsis if needed
  const needsEndEllipsis = rangeEnd < lastPage - 1;
  const suffix = needsEndEllipsis
    ? ["...", lastPage]
    : rangeEnd === lastPage - 1
    ? [lastPage]
    : [];

  return [...prefix, ...range, ...suffix];
}
export default constructPagination;
